const AuthPlugin = {
  install (Vue, options) {
    let auth = {
      idToken: null,
      email: null,
      // Remove all tokens from lagacy location (Security reason)
      removeTokensFromLegacyLocation: function () {
        localStorage.removeItem('chekt::last_email')
        localStorage.removeItem('chekt::last_refresh_token')
        localStorage.removeItem('chekt::id_token')
        localStorage.removeItem('chekt::refresh_token')
        localStorage.removeItem('access_token')
        localStorage.removeItem('id_token')
        localStorage.removeItem('expires_at')
        localStorage.removeItem('provider')
        localStorage.removeItem('connection')
        localStorage.removeItem('email')
        Vue.tool.deleteCookie('crt')
        Vue.tool.deleteCookie('email')
        Vue.tool.deleteCookie('chekt::connection')
        Vue.tool.deleteCookie('chekt::provider')
        Vue.tool.deleteCookie('chekt::ip_auth_dealer')
      },
      storeIdTokenToAuthService: function (token) {
        Vue.auth.idToken = token
      }
    }
    Vue.prototype.$auth = auth
    Vue.auth = auth
  }
}

export default AuthPlugin



// WEBPACK FOOTER //
// ./src/plugins/auth.js